import PropTypes from 'prop-types';
import useShallowEqualSelector from '../core/useShallowEqualSelector';
import { stylesPropType, vmPropTypes } from '../../global-prop-types';
import { useAppTimezone } from '../../global-hooks/useAppTimezone';

const DateFormatter = (props) => {
  const {
    styles, timestamp, dateTimeFormat, variant
  } = props;

  const { currentLocale } = useShallowEqualSelector((state) => state?.user);
  const appTimezone = useAppTimezone();
  const dateTimeFormatNew = { ...dateTimeFormat, timeZone: appTimezone };

  const dtFormatter = new Intl.DateTimeFormat(currentLocale, dateTimeFormatNew);
  let timestampFormatted;
  try {
    timestampFormatted = dtFormatter.format(new Date(timestamp));
  } catch (e) {
    return null;
  }

  return (
    <span
      className={`dateFormatter-wrapper ${variant || ''}`}
      style={styles?.wrapper}
    >
      {timestampFormatted}
    </span>
  );
};

DateFormatter.propTypes = {
  variant: PropTypes.string,
  styles: stylesPropType,
  timestamp: PropTypes.string,
  dateTimeFormat: PropTypes.shape({}),
};

DateFormatter.vmPropTypes = {
  variant: vmPropTypes.className,
  styles: { wrapper: vmPropTypes.styles },
  timestamp: vmPropTypes.timestamp,
  dateTimeFormat: vmPropTypes.object
};

DateFormatter.defaultProps = {
  variant: '',
  styles: { wrapper: {} },
  dateTimeFormat: {
    weekday: 'long',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    fractionalSecondDigits: 3,
    hour12: false
  }
};

export default DateFormatter;
